import styled from '@emotion/styled'

export const VatDeclarationReportWrapper = styled.div`
  flex: 1;
`
